// LINEの in-app ブラウザや他の共通クリック処理と衝突しないよう、クリックを“専有”して同一タブ遷移に
document.addEventListener(
  "click",
  function (e) {
    const a = e.target.closest(".js-line-share");
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    // in-app や popup ブロック対策：同一タブで確実に遷移
    location.assign(a.href);
  },
  true
);

(function () {
  const blocks = document.querySelectorAll(".js-career-block");
  let isSP = null; // 現在SPかどうかを記録
  let handlersAdded = false;

  function setupAccordion() {
    const nowSP = window.matchMedia("(max-width: 767px)").matches;

    // 状態が変わっていないなら何もしない
    if (nowSP === isSP) return;

    isSP = nowSP;

    if (isSP) {
      // --- スマホ（767px以下）: イベント追加 ---
      blocks.forEach((block) => {
        const ttl = block.querySelector(".js-career-ttl");

        // ハンドラを保存（削除できるようにする）
        const handler = () => block.classList.toggle("is-open");
        ttl._accordionHandler = handler;

        ttl.addEventListener("click", handler);
      });
      handlersAdded = true;

    } else {
      // --- PC（768px以上）: イベント削除、状態リセット ---
      if (handlersAdded) {
        blocks.forEach((block) => {
          const ttl = block.querySelector(".js-career-ttl");
          
          if (ttl._accordionHandler) {
            ttl.removeEventListener("click", ttl._accordionHandler);
            delete ttl._accordionHandler;
          }

          // 開閉状態をリセット
          block.classList.remove("is-open");
        });

        handlersAdded = false;
      }
    }
  }

  // 初回実行
  setupAccordion();

  // リサイズ時も実行
  window.addEventListener("resize", () => {
    setupAccordion();
  });
})();

